import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Link } from "react-router";
import { toast } from "react-toastify";
import {
  getStateAll,
  getGalaxySubjects,
  updateGalaxyStars,
} from "../../../api/subject.service";
import constant from "../../../utils/constant";
import Loader from "../../shared/loader/loader";
import AllowedTo from "../../shared/common/rbac";
import Permissions from "../../../utils/permissions";
import AccessDenied from "../../shared/common/accessDenied";

const DefaultSubjects = (props: any) => {
  const totalGrades = [1, 2, 3, 4, 5, 6];
  const [states, setStates] = useState([]);
  const [selectedStateId, setSelectedStateId] = useState<number>();
  const [contentAreaSubjects, setContentAreaSubjects] = useState<any>({
    subjectsData: [],
  });
  const [loading, setLoading] = useState<boolean>(false);
  const [missingGrades, setMissingGrades] = useState([]);

  useEffect(() => {
    getStates();
  }, []);

  const getStates = async () => {
    setLoading(true);
    const response = getStateAll(999, 1);
    const data = (await response).data;
    let newStateData = [];
    if (data.data.length > 0) {
      newStateData = data.data.map((eachContentData) => {
        return {
          value: eachContentData.stateId || 0,
          label: `${eachContentData.name}`,
        };
      });
    }
    setStates(newStateData);
    const firstState: any = newStateData[0];
    if (firstState?.value) {
      onStateChange(firstState?.value || 0);
      setSelectedStateId(firstState?.value || 0);
    }
  };

  const filterHandler = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const data: any = [];
    const table: any = document.getElementById("defaultTable");
    const input: any = table.getElementsByTagName("input");
    for (let z = 0; z < input.length; z++) {
      const initObj: any = {};
      const split = input[z].name.split("_");

      initObj.gradeId = split[1];
      if (split.includes("chk")) {
        initObj.subjectId = split[2];
        initObj.isActive = input[z].checked;
        data.push(initObj);
      }

      if (input[z].value && split.includes("custom")) {
        data.map((ds) => {
          if (ds.gradeId === split[1]) {
            ds["customStars"] = input[z].value;
            ds["stateId"] = selectedStateId;
          }
        });
      }
      if (input[z].value && split.includes("max")) {
        data.map((ds) => {
          if (ds.gradeId === split[1]) {
            ds["maxStars"] = input[z].value;
            ds["stateId"] = selectedStateId;
          }
        });
      }
    }
    setLoading(true);
    const resp = await updateGalaxyStars({
      subjectGalaxyStars: data,
      userId: props.profile?.userId,
    });
    if (resp && resp.data === 0) {
      toast.success("Updated Successfully");
    } else {
      toast.success("Something went wrong");
    }
    setLoading(false);
  };

  const onStateChange = async (stateId: number) => {
    setContentAreaSubjects({});

    setLoading(true);
    setSelectedStateId(stateId);
    const resp = await getGalaxySubjects(stateId);
    setLoading(false);

    let filterOutByGrade: any = [];
    if (resp?.data?.length > 0) {
      resp?.data.map((ds) => {
        const contentArea: any = {};
        contentArea.name = ds.contentArea;
        contentArea.id = ds.contentArea;
        contentArea.subjectGalaxyStars = [];

        if (ds.subjectGalaxyStars.length > 0) {
          ds.subjectGalaxyStars.map((subject) => {
            if (subject.gradeId <= 6) {
              contentArea.subjectGalaxyStars.push(subject);
            }
          });
        }
        contentArea.subjectGalaxyStars = Object.values(
          contentArea?.subjectGalaxyStars?.reduce(function (r, a) {
            r[a.gradeId] = r[a.gradeId] || [];
            r[a.gradeId].push(a);
            return r;
          }, Object.create(null))
        );
        filterOutByGrade.push(contentArea);
      });
    }

    filterOutByGrade = filterOutByGrade.sort((a, b) =>
      a.name > b.name ? 1 : -1
    );

    for (let i = 0; i < filterOutByGrade.length; i++) {
      const availableGrades: any = [];
      filterOutByGrade[i].subjectGalaxyStars.filter((item) => {
        item.filter((sub) => {
          const index = totalGrades.indexOf(sub.gradeId);

          if (index !== -1) {
            if (availableGrades.indexOf(sub.gradeId) == -1)
              availableGrades.push(sub.gradeId);
          }
        });
      });

      const n = totalGrades.length;
      const m = availableGrades.length;
      const missingArray = findMissing(totalGrades, availableGrades, n, m);
      for (let m = 0; m < missingArray.length; m++) {
        filterOutByGrade[i].subjectGalaxyStars.splice(
          missingArray[m] - 1,
          0,
          []
        );
      }
    }

    const calculation = await getValues(filterOutByGrade);

    setContentAreaSubjects({
      subjectsData: filterOutByGrade,
      calculation,
    });
  };

  function findMissing(a, b, n, m) {
    const arr: any = [];
    for (let i = 0; i < n; i++) {
      let j;

      for (j = 0; j < m; j++) if (a[i] == b[j]) break;

      if (j == m) arr.push(a[i]);
    }
    return arr;
  }

  const getValues = (data) => {
    return new Promise((resolve) => {
      let ds: any = [];
      for (let i = 0; i < data?.length; i++) {
        data[i]?.subjectGalaxyStars.map((data) => {
          for (let j = 0; j < data?.length; j++) {
            ds.push(data[j]);
          }
        });
      }
      ds = Object.values(
        ds?.reduce(function (r, a) {
          r[a.gradeId] = r[a.gradeId] || [];
          r[a.gradeId].push(a);
          return r;
        }, Object.create(null))
      );

      const sumOfData = ds.map((data, i) => {
        const ds = {};
        const missingGrades: any = [];
        ds["gradeId"] = data[0].gradeId;
        ds["defaultMaxStars"] = data
          .map((d) => (d.isActive ? d.defaultMaxStars : 0))
          .reduce((x, y) => x + y);
        ds["maxStars"] = data.map((d) => d.maxStars).reduce((x, y) => x + y);
        ds["customStars"] = data.map((d) =>
          d.isActive ? d.customStars : 0
        )[0];
        return ds;
      });

      const availableGrades: any = [];
      const missingGrade: any = [];
      for (let i = 0; i < sumOfData.length; i++) {
        availableGrades.push(sumOfData[i].gradeId);
      }
      for (let j = 0; j < totalGrades.length; j++) {
        if (availableGrades.indexOf(totalGrades[j]) === -1) {
          missingGrade.push(totalGrades[j]);
        }
      }

      for (let m = 0; m < missingGrade.length; m++) {
        const defaultObj = {
          gradeId: missingGrade[m],
          defaultMaxStars: 0,
          maxStars: 0,
          customStars: 0,
        };
        sumOfData.splice(missingGrade[m] - 1, 0, defaultObj);
      }
      resolve(sumOfData);
    });
  };

  const sumOfValues = (contentAreaSubjects, idx) => {
    const obj: any = {};

    obj.maxStars = contentAreaSubjects?.calculation[idx]?.defaultMaxStars;

    obj.customStars = contentAreaSubjects?.calculation[idx]?.customStars;
    obj.defaultMaxStars =
      contentAreaSubjects?.calculation[idx]?.defaultMaxStars;

    return obj;
  };

  const checkCurrentValueOnChange = (id) => {
    const elem: any = document.getElementsByName(`custom_${id}`);
    const elem1: any = document.getElementsByName(`max_${id}`);

    if (elem && elem.length && parseInt(elem[0]?.value) > 0) {
      if (elem1 && elem1.length) elem1[0].style.pointerEvents = "none";
    } else {
      if (elem1 && elem1.length) elem1[0].style.pointerEvents = "unset";
    }
  };
  const handleSubjectChange = (e: any, data: any, idx: number) => {
    const maxElement: any = document.getElementsByName(`max_${idx + 1}`);
    const percentElement: any = document.getElementsByName(
      `percent_${idx + 1}`
    );
    const checkBoxElement: any = document.getElementsByName(
      e.currentTarget.name
    );

    if (e.currentTarget.checked) {
      maxElement[0].value =
        parseInt(maxElement[0].value ? maxElement[0].value : 0) +
        data?.defaultMaxStars;
      percentElement[0].value = parseInt(maxElement[0].value) * 0.6;
      let name = checkBoxElement[0].name;
      name = name.replace("false", "true");
      checkBoxElement[0].name = name;
    } else {
      maxElement[0].value =
        parseInt(maxElement[0].value) - data?.defaultMaxStars;
      percentElement[0].value = parseInt(maxElement[0].value) * 0.6;
    }
  };

  const formatSubjectData = (data: any, gradeId: number) => {
    const arr: any = [];
    for (let i = 0; i < data.length; i++) {
      if (data[i][0].gradeId != gradeId) {
        arr.push([]);
      } else {
        arr.push(data[i]);
      }
    }

    return arr;
  };

  return (
    <AllowedTo
      perform={Permissions.galaxy_subjects_view}
      no={() => <AccessDenied />}
    >
      {loading && <Loader />}

      <div className="flex-1 overflow-auto">
        <div className=" h-auto min-h-half w-full rounded-bl-3xl bg-site-teal px-8 py-8 pt-0 pb-14 mt-7 ">
          <div className="relative  py-1">
            <div className="overlay-image-main pointer-events-none fixed left-0 top-0 w-screen h-screen z-20"></div>
            <div className="flex items-center justify-between">
              <h3 className="text-lg font-light text-gray-900">
                Default Subjects
              </h3>
            </div>
            <div className="flex">
              <div className="w-1/6 mr-14">
                <ul className="cursor-pointer">
                  {states?.map((state: any, i) => (
                    <li
                      key={i}
                      className={`${
                        selectedStateId === parseInt(state.value)
                          ? "bg-primary-color text-white"
                          : "bg-white text-gray-700 "
                      } "cursor-pointer px-3 py-2 font-light text-sm dark:text-white tracking-wider text-left"`}
                      onClick={() => onStateChange(parseInt(state.value))}
                    >
                      {state?.label}
                    </li>
                  ))}
                </ul>
              </div>
              <form onSubmit={filterHandler} className="w-4/5">
                <AllowedTo perform={Permissions.galaxy_subjects_modify}>
                  <div className="pt-6 border-b pb-6 flex justify-between">
                    {contentAreaSubjects?.subjectsData?.length > 0 && (
                      <button
                        type="submit"
                        className="h-8 mt-8 inline-flex items-center px-3 py-1 border border-transparent text-sm leading-4 rounded-md shadow-xs text-white dark:text-white bg-primary-color hover:bg-secondary-color focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color hover:shadow-lg transition ease-in-out duration-300"
                      >
                        Update
                      </button>
                    )}
                  </div>
                </AllowedTo>

                <div className="mt-4">
                  <div className="flex flex-col mt-1">
                    <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                      <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                        <div className="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
                          {contentAreaSubjects?.subjectsData && (
                            <table
                              className="min-w-full divide-y divide-gray-200"
                              id="defaultTable"
                            >
                              <thead className="bg-primary-color">
                                <tr>
                                  <th scope="col" className="w-3"></th>
                                  {contentAreaSubjects?.subjectsData?.map(
                                    (contentArea, i) => (
                                      <th
                                        key={i}
                                        scope="col"
                                        className=" px-3 py-2 font-light text-sm text-white dark:text-white tracking-wider text-left"
                                      >
                                        {contentArea.name}
                                      </th>
                                    )
                                  )}
                                  <th
                                    scope="col"
                                    className=" px-3 py-2 font-light text-sm text-white dark:text-white tracking-wider text-center"
                                  >
                                    Max
                                  </th>
                                  <th
                                    scope="col"
                                    className=" px-3 py-2 font-light text-sm text-white dark:text-white tracking-wider text-center"
                                  >
                                    60%
                                  </th>
                                  <th
                                    scope="col"
                                    className=" px-3 py-2 font-light text-sm text-white dark:text-white tracking-wider text-center"
                                  >
                                    Custom
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {contentAreaSubjects &&
                                  contentAreaSubjects?.subjectsData &&
                                  contentAreaSubjects?.subjectsData[0]?.subjectGalaxyStars?.map(
                                    (ds, idx) => {
                                      return (
                                        <tr
                                          key={idx}
                                          className={
                                            idx % 2 === 0
                                              ? "bg-white"
                                              : "bg-gray-100"
                                          }
                                        >
                                          <td className="px-3 py-2 capitalize  text-sm text-left font-normal text-gray-500">
                                            <div className="flex justify-center w-3">
                                              <span className="-rotate-90 whitespace-nowrap text-primary-color px-1">
                                                {idx == 0
                                                  ? "K"
                                                  : `Grade ${idx}`}
                                              </span>
                                            </div>
                                          </td>
                                          {contentAreaSubjects?.subjectsData?.map(
                                            (dsx, i) => (
                                              <td
                                                key={i}
                                                valign="top"
                                                className="px-3 py-2 capitalize  text-sm text-left font-normal text-gray-500"
                                              >
                                                <div className="flex flex-col gap-1">
                                                  {contentAreaSubjects?.subjectsData[
                                                    i
                                                  ]?.subjectGalaxyStars[
                                                    idx
                                                  ]?.map((data, i) => (
                                                    <span
                                                      key={i}
                                                      className=" flex"
                                                    >
                                                      <input
                                                        defaultChecked={
                                                          data.isActive
                                                        }
                                                        name={
                                                          "chk_" +
                                                          data.gradeId +
                                                          "_" +
                                                          data.subjectId +
                                                          "_" +
                                                          data.isActive
                                                        }
                                                        type="checkbox"
                                                        onClick={(e) =>
                                                          handleSubjectChange(
                                                            e,
                                                            data,
                                                            idx
                                                          )
                                                        }
                                                        className="mt-1 mr-1.5 focus:ring-primary-color h-4 w-4 text-primary-color border-gray-300 rounded"
                                                      />
                                                      <Link
                                                        className="text-indigo-600 hover:text-indigo-500 hover:underline"
                                                        to={constant.SUBJECTDETAIL.replace(
                                                          ":id",
                                                          data?.subjectId
                                                        )}
                                                      >
                                                        {data.subject}
                                                      </Link>
                                                    </span>
                                                  ))}
                                                </div>
                                              </td>
                                            )
                                          )}
                                          <td className="px-3 py-2 capitalize  text-sm text-left font-normal text-gray-500">
                                            <div className="flex justify-center">
                                              <input
                                                disabled
                                                defaultValue={
                                                  sumOfValues(
                                                    contentAreaSubjects,
                                                    idx
                                                  ).defaultMaxStars
                                                }
                                                name={`max_${idx + 1}`}
                                                type="number"
                                                className={`${
                                                  sumOfValues(
                                                    contentAreaSubjects,
                                                    idx
                                                  ).customStars > 0
                                                    ? "pointer-events-none"
                                                    : ""
                                                } block w-16 mt-1 border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-primary-color focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white sm:text-sm`}
                                              />
                                            </div>
                                          </td>
                                          <td className="px-3 py-2 capitalize  text-sm text-left font-normal text-gray-500">
                                            <div className="flex justify-center">
                                              <input
                                                disabled
                                                defaultValue={(
                                                  sumOfValues(
                                                    contentAreaSubjects,
                                                    idx
                                                  ).defaultMaxStars * 0.6
                                                ).toFixed(2)}
                                                name={`percent_${idx + 1}`}
                                                type="number"
                                                className="block w-20 mt-1 border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-primary-color focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white sm:text-sm"
                                              />
                                            </div>
                                          </td>
                                          <td className="px-3 py-2 capitalize  text-sm text-left font-normal text-gray-500">
                                            <div className="flex justify-center">
                                              <input
                                                onChange={() =>
                                                  checkCurrentValueOnChange(
                                                    idx + 1
                                                  )
                                                }
                                                defaultValue={
                                                  sumOfValues(
                                                    contentAreaSubjects,
                                                    idx
                                                  ).customStars
                                                }
                                                name={`custom_${idx + 1}`}
                                                type="number"
                                                className="block w-16 mt-1 border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-primary-color focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white sm:text-sm"
                                              />
                                            </div>
                                          </td>
                                        </tr>
                                      );
                                    }
                                  )}
                              </tbody>
                            </table>
                          )}
                          {contentAreaSubjects?.subjectsData?.length === 0 && (
                            <p className="p-2">{`${
                              selectedStateId
                                ? "No Records Found"
                                : "Please select state"
                            }`}</p>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </AllowedTo>
  );
};

export default connect((state: any) => {
  return {
    profile: state.profile,
  };
})(DefaultSubjects);
